module.exports = "<!DOCTYPE html>\r\n<html lang=\"en\">\r\n<head>\r\n    <meta charset=\"UTF-8\">\r\n    <title></title>\r\n</head>\r\n<body>\r\n\r\n</body>\r\n</html>"


//////////////////
// WEBPACK FOOTER
// G:/3csoft/client-final/src/app/layout/breadcrumb/breadcrumb.template.html
// module id = ../../../../../src/app/layout/breadcrumb/breadcrumb.template.html
// module chunks = main